// Compresses an IPv6 address the way `IPAddr` does, so a field shows what will
// actually be stored: lower case, no leading zeros, and the longest run of zero
// groups replaced by "::".
//
// Anything this cannot confidently parse is returned untouched. The point is to
// tidy a valid address, never to guess at a broken one — `IpAddressValidator`
// judges those, with a message naming the value.
export function normaliseIpv6(text) {
  const raw = String(text == null ? '' : text).trim().toLowerCase()
  if (!raw || !/^[0-9a-f:]+$/.test(raw)) return raw

  const doubleColons = (raw.match(/::/g) || []).length
  if (doubleColons > 1) return raw

  let groups
  if (doubleColons === 1) {
    const [before, after] = raw.split('::')
    const head = before ? before.split(':') : []
    const tail = after ? after.split(':') : []
    const missing = 8 - head.length - tail.length
    if (missing < 1) return raw
    groups = head.concat(new Array(missing).fill('0'), tail)
  } else {
    groups = raw.split(':')
    if (groups.length !== 8) return raw
  }

  if (!groups.every((group) => /^[0-9a-f]{1,4}$/.test(group))) return raw
  groups = groups.map((group) => group.replace(/^0+(?=.)/, ''))

  // The longest run of zero groups is compressed, and only a run of two or more:
  // "::" standing in for a single group is no shorter. The leftmost run wins a
  // tie, which is what every other tool does.
  let bestStart = -1
  let bestLength = 0
  let start = -1
  groups.concat(['x']).forEach((group, index) => {
    if (group === '0') {
      if (start < 0) start = index
    } else if (start >= 0) {
      if (index - start > bestLength) {
        bestLength = index - start
        bestStart = start
      }
      start = -1
    }
  })

  if (bestLength < 2) return groups.join(':')

  const head = groups.slice(0, bestStart).join(':')
  const tail = groups.slice(bestStart + bestLength).join(':')
  return `${head}::${tail}`
}
